import type * as babel from "@babel/core";

export const logInspectorFunctionName = "$NATTO_LOG";

const logValueStore: Record<string, any[]> = {};
export function getLogInspectorValues(paneId: string): any[] | undefined {
  return logValueStore[paneId];
}
export function setLogInspectorValues(paneId: string, values: any[]) {
  logValueStore[paneId] = values;
}

export function babelLogInspectorPlugin(
  {
    types: t,
  }: {
    types: typeof babel.types;
  },
  { prefixLength }: { prefixLength: number }
): babel.PluginObj {
  return {
    visitor: {
      VariableDeclarator(path, state) {
        if (
          path.node.init != null &&
          path.node.id.start !== null &&
          path.node.id.end !== null &&
          t.isIdentifier(path.node.id)
        ) {
          path
            .get("init")
            .replaceWith(
              t.callExpression(t.identifier(logInspectorFunctionName), [
                path.node.init,
                t.objectExpression([
                  t.objectProperty(
                    t.stringLiteral("start"),
                    t.numericLiteral(path.node.id.start - prefixLength)
                  ),
                  t.objectProperty(
                    t.stringLiteral("end"),
                    t.numericLiteral(path.node.id.end - prefixLength)
                  ),
                  t.objectProperty(
                    t.stringLiteral("name"),
                    t.stringLiteral(path.node.id.name)
                  ),
                ]),
              ])
            );
        }
      },
      AssignmentExpression(path, state) {
        if (
          path.node.operator === "=" &&
          path.node.left.start !== null &&
          path.node.left.end !== null &&
          t.isIdentifier(path.node.left)
        ) {
          path
            .get("right")
            .replaceWith(
              t.callExpression(t.identifier(logInspectorFunctionName), [
                path.node.right,
                t.objectExpression([
                  t.objectProperty(
                    t.stringLiteral("start"),
                    t.numericLiteral(path.node.left.start - prefixLength)
                  ),
                  t.objectProperty(
                    t.stringLiteral("end"),
                    t.numericLiteral(path.node.left.end - prefixLength)
                  ),
                  t.objectProperty(
                    t.stringLiteral("name"),
                    t.stringLiteral(path.node.left.name)
                  ),
                ]),
              ])
            );
        }
      },
      Identifier(path, state) {
        if (
          path.findParent(
            (path) => path.isPattern() || path.isUpdateExpression()
          ) !== null ||
          path.parentKey === "property" ||
          path.parentKey === "key" ||
          path.parentKey === "id" ||
          path.listKey === "params" ||
          path.key === "id" ||
          (t.isAssignmentExpression(path.parent) && path.key === "left") ||
          typeof path.node.start !== "number" ||
          typeof path.node.end !== "number"
        ) {
          return;
        }
        path.replaceWith(
          t.callExpression(t.identifier(logInspectorFunctionName), [
            path.node,
            t.objectExpression([
              t.objectProperty(
                t.stringLiteral("start"),
                t.numericLiteral(path.node.start - prefixLength)
              ),
              t.objectProperty(
                t.stringLiteral("end"),
                t.numericLiteral(path.node.end - prefixLength)
              ),
              t.objectProperty(
                t.stringLiteral("name"),
                t.stringLiteral(path.node.name)
              ),
            ]),
          ])
        );
        path.skip();
      },
    },
  };
}
